export const TOTAL_COUNT_COMPANY = "TOTAL_COUNT_COMPANY";
export const REQUEST_API_START = "REQUEST_API_START";
export const REQUEST_API_SUCCESS = "REQUEST_API_SUCCESS";
export const REQUEST_API_ERROR = "REQUEST_API_ERROR";

export const REQUEST_API_COMPANY_START = "REQUEST_API_COMPANY_START";
export const REQUEST_API_COMPANY_ERROR = "REQUEST_API_COMPANY_ERROR";

export const REQUEST_GET_ADMIN_LIST_START = "REQUEST_GET_ADMIN_LIST_START";
export const REQUEST_GET_ADMIN_LIST_SUCCESS = "REQUEST_GET_ADMIN_LIST_SUCCESS";
export const REQUEST_GET_ADMIN_LIST_ERROR = "REQUEST_GET_ADMIN_LIST_ERROR";

export const REQUEST_GET_LIST_FILTER_COMPANY_START = "REQUEST_GET_LIST_FILTER_COMPANY_START";
export const REQUEST_GET_LIST_FILTER_COMPANY_SUCCESS = "REQUEST_GET_LIST_FILTER_COMPANY_SUCCESS";
export const REQUEST_GET_LIST_FILTER_COMPANY_ERROR = "REQUEST_GET_LIST_FILTER_COMPANY_ERROR";

export const REQUEST_CREATE_COMPANY = "REQUEST_CREATE_COMPANY";
export const REQUEST_CREATE_LOGO_START = "REQUEST_ADD_LOGO";
export const REQUEST_CREATE_LOGO_SUCCESS = "REQUEST_ADD_LOGO";
export const REQUEST_CREATE_LOGO_ERROR = "REQUEST_ADD_LOGO";

export const REQUEST_DELETE_START = "REQUEST_DELETE_START";
export const REQUEST_DELETE_BY_ID = "REQUEST_DELETE_BY_ID";
export const REQUEST_DELETE_ERROR = "REQUEST_DELETE_ERROR";

export const REQUEST_UPDATE_BY_ID = "REQUEST_UPDATE_BY_ID";